import { useTranslation } from 'react-i18next'

// Buyer/seller org classification filter for Kjøpere and Selgere (#475).
// Module-local — not part of useBruktbilFilters, since only these two tabs
// use it (mirrors how Ståtid keeps its Spørring filters page-local).
export const CLASSIFICATION_OPTIONS = [
  { value: 'bilbransje', labelKey: 'classification.bilbransje' },
  { value: 'Leasingselskap', labelKey: 'classification.leasingselskap' },
  { value: 'bilutleieselskap', labelKey: 'classification.bilutleieselskap' },
  { value: 'kommune', labelKey: 'classification.kommune' },
  { value: 'other_organization', labelKey: 'classification.annet' },
] as const

interface Props {
  value: string | null
  onChange: (value: string | null) => void
  label: string // "Kjøpers type:" / "Selgers type:"
}

export default function ClassificationFilter({ value, onChange, label }: Props) {
  const { t } = useTranslation('bruktbil')
  return (
    <div className="flex items-center gap-3 flex-wrap" data-testid="classification-filter">
      <span className="text-xs text-gray-500 dark:text-gray-400">{label}</span>
      <div className="flex rounded-sm border border-gray-300 dark:border-gray-600 overflow-hidden text-xs">
        <button
          onClick={() => onChange(null)}
          className={`px-3 py-1 transition-colors ${
            !value
              ? 'bg-primary-600 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
          }`}
        >
          {t('common.alle')}
        </button>
        {CLASSIFICATION_OPTIONS.map(opt => (
          <button
            key={opt.value}
            onClick={() => onChange(opt.value)}
            className={`px-3 py-1 border-l border-gray-300 dark:border-gray-600 transition-colors ${
              value === opt.value
                ? 'bg-primary-600 text-white'
                : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
            }`}
          >
            {t(opt.labelKey)}
          </button>
        ))}
      </div>
    </div>
  )
}
